export default __webpack_public_path__ + "static/media/Map_placeholder.a0cd347d.jpg";